var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_38715",
    "data-name": "Group 38715",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14915",
    "data-name": "Rectangle 14915",
    width: 16,
    height: 16,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ellipsis",
    transform: "translate(1 6.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36715",
    "data-name": "Path 36715",
    d: "M195.5,1.75A1.75,1.75,0,1,1,193.75,0,1.75,1.75,0,0,1,195.5,1.75Zm0,0",
    transform: "translate(-186.75)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36716",
    "data-name": "Path 36716",
    d: "M3.5,1.75A1.75,1.75,0,1,1,1.75,0,1.75,1.75,0,0,1,3.5,1.75Zm0,0",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36717",
    "data-name": "Path 36717",
    d: "M387.5,1.75A1.75,1.75,0,1,1,385.75,0,1.75,1.75,0,0,1,387.5,1.75Zm0,0",
    transform: "translate(-373.5)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/three-dots.ca59ced69df5e9a65779475300d2bdc0.svg";
export { ForwardRef as ReactComponent };